/**
 * DrilldownContext — global modal trigger for any chart/KPI element.
 *
 * Wrap the app (Dashboard) with <DrilldownProvider> and any child component
 * can call useDrilldown() to open the universal drilldown modal:
 *
 *   const { openDrilldown } = useDrilldown();
 *   openDrilldown({ title: "Hot Prospects", metric: "leads_hot_prospect" });
 *
 * This avoids prop-drilling through every chart/panel.
 */
import { createContext, useContext, useState, useCallback } from "react";
import UniversalDrilldownModal from "./UniversalDrilldownModal";

const Ctx = createContext({ openDrilldown: () => {} });

export const useDrilldown = () => useContext(Ctx);

export function DrilldownProvider({ children }) {
  const [drill, setDrill] = useState(null);
  const openDrilldown = useCallback((payload) => setDrill(payload), []);
  const close = useCallback(() => setDrill(null), []);
  return (
    <Ctx.Provider value={{ openDrilldown }}>
      {children}
      <UniversalDrilldownModal open={!!drill} drill={drill} onClose={close} />
    </Ctx.Provider>
  );
}
